import { useEffect } from 'react'

const useWindowResize = () => {
    useEffect(() => {
        require('events').EventEmitter.defaultMaxListeners = 60

        // Handler to call on window resize
        function handleResize() {
            // Update the element's size
            const vh = window.innerHeight * 0.01
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        }

        // Add event listener
        window.addEventListener('resize', handleResize)

        // Call handler right away so state gets updated with initial window size
        handleResize()

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize)
    }, [])
}

export default useWindowResize
